export default __webpack_public_path__ + "static/media/manwithlaptop.11f143c6b7b974838faae781751af178.svg";